import { BreakpointName } from './MediaQueryContext.js';

const Breakpoints = {
    M: 768,
    L: 1024,
    XL: 1440
};
/**
 * Checks current viewport width against our Breakpoints enumeration
 * and returns the one that is currently active
 */ const isMinWidth = (width)=>window.matchMedia(`(min-width: ${width}px)`).matches
;
const getCurrentBreakpoint = ()=>{
    if (isMinWidth(Breakpoints.XL)) {
        return BreakpointName.DESKTOP;
    } else if (isMinWidth(Breakpoints.L)) {
        return BreakpointName.TABLET_LANDSCAPE;
    } else if (isMinWidth(Breakpoints.M)) {
        return BreakpointName.TABLET_PORTRAIT;
    } else {
        return BreakpointName.PHONE;
    }
};

export { Breakpoints, getCurrentBreakpoint };
//# sourceMappingURL=helpers.js.map
